// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  awairInternalHost: 'https://stg-internal.awair.is/v1/',

  mobileAppHost: 'https://stg-mobile-app.awair.is/v1/',

  awairB2bHost: 'https://stg-enterprise.awair.is/v1/',
  afbV1Host: 'https://stg-dashboard.awair.is/v1/',
  afbV2Host: 'https://stg-dashboard.awair.is/v2/',

  afbGraphqlHost: 'https://stg-dashboard.awair.is/graphql',
  afbTimeSeriesGraphqlHost: 'https://stg-dashboard.awair.is/timeline/graphql',
  afbUnprotectedGraphqlHost: 'https://stg-dashboard.awair.is/unprotected-graphql',

  awairAccountHost: 'https://stg-account.awair.is/v1/',
  awairAfbHost: 'https://stg-afb-api.awair.is/v1/',

  oAuthLogin: 'https://stg-oauth-login.awair.is/',
  afbHost: 'https://stg-dashboard.getawair.com'
};
